import { InfoCircle, TagUser, Clock } from "iconsax-react";
import type { Icon } from "iconsax-react";
import type { ContractChoice, ContractFormValues, SectionId, WorkFormat } from "./types";

export const WORK_FORMAT_CHOICES: ContractChoice<WorkFormat>[] = [
  { value: "onsite", labelKey: "contracts.workFormat.onsite" },
  { value: "remote", labelKey: "contracts.workFormat.remote" },
  { value: "hybrid", labelKey: "contracts.workFormat.hybrid" },
];

export const ORDER_ACKNOWLEDGED = "order_acknowledged";
export const ORDER_PENDING = "order_pending";
export const ORDER_UPLOADED = "order_uploaded";
export const CONTRACT_COMPLETED = "completed";
export const CONTRACT_SIGNED = "contract_signed";
export const JOB_APP_PENDING = "job_app_pending";
export const JOB_APP_REVIEW = "job_app_review";
export const JOB_APP_APPROVED = "job_app_approved";

export const SIGNING_STATUS_FULLY_SIGNED = 3;

export const SECTIONS: { id: SectionId; icon: Icon }[] = [
  { id: "basic_info", icon: InfoCircle },
  { id: "position_duties", icon: TagUser },
  { id: "work_schedule", icon: Clock },
];

export const SECTION_FIELDS: Record<SectionId, (keyof ContractFormValues | string)[]> = {
  basic_info: ["sign_date", "start_date", "work_city_id", "employee_address_ru", "employee_address_kk"],
  position_duties: ["job_position_ru", "job_duties_ru", "job_position_kk", "job_duties_kk"],
  work_schedule: [
    "working_days_list",
    "work_start_time",
    "work_end_time",
    "has_break",
    "break_start_time",
    "break_end_time",
    "trial_period",
    "is_executive",
    "trial_duration_months",
    "work_format",
    "salary_amount",
  ],
};

export const DEFAULT_CONTRACT_VALUES: ContractFormValues = {
  sign_date: "",
  start_date: "",
  work_city_id: null,
  employee_address_ru: "",
  employee_address_kk: "",
  job_position_ru: "",
  job_duties_ru: [""],
  job_position_kk: "",
  job_duties_kk: [""],
  working_days_list: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  work_start_time: "09:00",
  work_end_time: "18:00",
  has_break: true,
  break_start_time: "13:00",
  break_end_time: "14:00",
  trial_period: false,
  is_executive: false,
  trial_duration_months: undefined,
  work_format: undefined,
  salary_amount: "",
  is_parallel_worker: false,
  contract_number: "",
};
